// TemplatePreview.jsx — full-screen A4 certificate preview modal

import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const TemplatePreview = ({
  html,
  title = 'Certificate Preview',
  fileName = 'certificate',
  onClose,
  showExportButtons = true,
}) => {
  const printAreaRef = useRef(null);

  const handlePrint = () => {
    const win = window.open('', '_blank');
    win.document.write(
      `<!DOCTYPE html><html><head><title>${title}</title>` +
      `<style>
        @page { size: A4 portrait; margin: 10mm; }
        * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; box-sizing: border-box; }
        html, body { margin: 0; padding: 0; width: 100%; }
        body > div { min-height: calc(297mm - 20mm); width: 100%; }
      </style></head>` +
      `<body>${html}</body></html>`
    );
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const handlePDF = async () => {
    if (!printAreaRef.current) return;
    try {
      const canvas = await html2canvas(printAreaRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const w = pdf.internal.pageSize.getWidth();
      const h = (canvas.height * w) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, w, h);
      pdf.save(`${fileName}.pdf`);
    } catch (err) {
      console.error('PDF generation error:', err);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="tpl-overlay" onClick={handleOverlayClick}>

      <div className="tpl-modal">

        {/* Header */}
        <div className="tpl-modal-header">
          <div className="tpl-modal-title">
            <span className="tpl-modal-icon">📄</span>
            {title}
          </div>
          <div className="tpl-modal-actions">
            {showExportButtons && (
              <>
                <button className="tpl-btn tpl-btn--print" onClick={handlePrint}>
                  🖨 Print
                </button>
                <button className="tpl-btn tpl-btn--pdf" onClick={handlePDF}>
                  📥 Download PDF
                </button>
              </>
            )}
            <button className="tpl-btn tpl-btn--close" onClick={onClose}>
              ✕ Close
            </button>
          </div>
        </div>

        {/* Body — A4 scaled preview */}
        <div className="tpl-modal-body">
          <div className="tpl-a4-wrap">
            <div
              ref={printAreaRef}
              className="tpl-a4"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
        </div>

      </div>

    </div>
  );
};

export default TemplatePreview;
